export type MediaType = "movie" | "tv" | "variety";

export interface MediaItem {
  id: string;
  title: string;
  originalTitle: string;
  type: MediaType;
  genres: string[];
  region: string;
  year: number;
  rating: number;
  episodes: string;
  director: string;
  cast: string[];
  tagline: string;
  summary: string;
  synopsis: string;
  tags: string[];
  heat: number;
  cover: string;
  backdrop: string;
}

export const mediaList: MediaItem[] = [
  {
    id: "m001",
    title: "雾港迷踪",
    originalTitle: "THE FOG HARBOR",
    type: "movie",
    genres: ["悬疑", "犯罪", "剧情"],
    region: "中国大陆",
    year: 2024,
    rating: 8.7,
    episodes: "118 分钟",
    director: "沈望舒",
    cast: ["程砚舟", "林未晞", "陆昀", "何蔓"],
    tagline: "雾散之前，没有人是清白的。",
    summary:
      "一座终年被雾笼罩的港口小城，接连出现三起无名失踪案。退休海警顾行舟被旧友请回调查，却发现所有线索都指向自己二十年前签下的一份航行日志。",
    synopsis:
      "雾气从海面漫上来的时候，港口的灯总是先灭掉一盏。前三名失踪者互不相识，却在同一天出现在同一份货单上。顾行舟沿着废弃码头一路查进去，遇见了沉默的灯塔看守、开夜间渔船的老同学，以及一个总在雨里等人的女孩。真相像退潮后的礁石一层层露出来——那场被写进档案的海难，其实从来没有结束。影片以冷冽的港口光影包裹一段关于赎罪与沉默的故事，节奏克制，余味很长。",
    tags: ["港口", "悬疑推理", "旧案重查", "赎罪"],
    heat: 9820,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20lone%20silhouette%20on%20a%20foggy%20harbor%20pier%20at%20dusk%2C%20warm%20peach%20and%20dusty%20rose%20color%20palette%2C%20drifting%20mist%2C%20distant%20cranes%20and%20ship%20lights%2C%20dramatic%20side%20lighting%2C%20subtle%20film%20grain%2C%20minimal%20elegant%20key%20art&width=480&height=672&seq=mt-m001-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20shot%20of%20a%20misty%20harbor%20town%20at%20dusk%20with%20a%20single%20figure%20walking%20along%20a%20wooden%20pier%2C%20warm%20peach%20sky%20over%20cold%20water%2C%20soft%20fog%20layers%2C%20ships%20and%20cranes%20in%20silhouette%2C%20moody%20atmospheric%20lighting%2C%20film%20still&width=1600&height=900&seq=mt-hero-m001&orientation=landscape",
  },
  {
    id: "m002",
    title: "星海拾光",
    originalTitle: "LIGHT UPON THE SEA",
    type: "movie",
    genres: ["科幻", "爱情", "剧情"],
    region: "中国大陆",
    year: 2025,
    rating: 8.9,
    episodes: "132 分钟",
    director: "祁南",
    cast: ["周叙白", "苏忆安", "许澈"],
    tagline: "我们把没说出口的话，留给了星空。",
    summary:
      "天文观测员江野在盐湖深处收到一段来自七年前的信号，声音属于早已离开的女孩。他决定用三个夜晚，把那段对话重新走完。",
    synopsis:
      "盐湖在夜里像一面巨大的镜子，星星落进去就再也捞不出来。江野守着快要退役的观测站，某天设备里忽然出现一段旧录音——那是林见夏离开前留下的最后一段观测日志。为了弄清楚信号为何延迟了七年，他每晚沿着同一条路走向湖心，白天则在镇上的旧书店里寻找她留下的痕迹。影片用极简的场景与大量留白，讲述两个习惯把心事藏起来的人，如何在星海之间补上一句迟到很久的告白。",
    tags: ["星空", "时空", "克制浪漫", "盐湖"],
    heat: 9450,
    cover:
      "https://readdy.ai/api/search-image?query=Dreamy%20cinematic%20poster%20of%20two%20small%20figures%20standing%20on%20a%20salt%20flat%20beneath%20a%20vast%20starry%20sky%2C%20soft%20peach%20and%20amber%20nebula%20glow%2C%20reflective%20shallow%20water%2C%20gentle%20lens%20flare%2C%20romantic%20science%20fiction%20mood%2C%20fine%20film%20grain%2C%20minimal%20key%20art&width=480&height=672&seq=mt-m002-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20film%20still%20of%20a%20mirror%20like%20salt%20flat%20under%20an%20immense%20starry%20sky%2C%20warm%20peach%20horizon%20glow%2C%20two%20tiny%20silhouettes%20standing%20apart%2C%20soft%20nebula%20clouds%2C%20reflections%20in%20shallow%20water%2C%20romantic%20sci%20fi%20atmosphere&width=1600&height=900&seq=mt-hero-m002&orientation=landscape",
  },
  {
    id: "m003",
    title: "长街晚风",
    originalTitle: "EVENING BREEZE",
    type: "movie",
    genres: ["剧情", "家庭"],
    region: "中国香港",
    year: 2023,
    rating: 8.4,
    episodes: "104 分钟",
    director: "黎见川",
    cast: ["陈开明", "余素心", "黎小满", "郑舟"],
    tagline: "家不是一间屋子，是那盏一直亮着的灯。",
    summary:
      "在外漂泊十年的阿满回到老城区，发现母亲把家里的旧铺面改成了糖水店。一碗糖水的味道，让他重新面对这个家所有没能说清的事。",
    synopsis:
      "长街的白天很短，傍晚风一来，整条街都飘着糖水的甜味。阿满带着一身疲惫回家，本打算只住三天，却被母亲留下的一本账本绊住了脚。账本上记的不是钱，而是这些年街坊邻居家里的喜事与难处。随着铺面的租约到期，一家人的旧矛盾被重新翻开。影片在街市、骑楼和黄昏的天台之间流动，用日常的烟火气讲一个关于原谅与留下的故事。",
    tags: ["老城", "家庭和解", "市井烟火", "慢节奏"],
    heat: 7310,
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20poster%20of%20an%20old%20town%20street%20with%20hanging%20lanterns%20and%20laundry%20lines%20at%20night%2C%20soft%20peach%20streetlight%20glow%2C%20bicycle%20leaning%20on%20a%20brick%20wall%2C%20gentle%20evening%20haze%2C%20nostalgic%20family%20drama%20mood%2C%20painterly%20key%20art&width=480&height=672&seq=mt-m003-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Warm%20evening%20street%20scene%20in%20an%20old%20Chinese%20town%20with%20glowing%20lanterns%2C%20small%20dessert%20shop%20with%20steam%20rising%2C%20peach%20and%20amber%20light%2C%20bicycles%20and%20wooden%20signboards%2C%20cinematic%20family%20drama%20film%20still&width=1600&height=900&seq=mt-hero-m003&orientation=landscape",
  },
  {
    id: "m004",
    title: "第七次日落",
    originalTitle: "THE SEVENTH SUNSET",
    type: "movie",
    genres: ["科幻", "悬疑", "冒险"],
    region: "欧美",
    year: 2025,
    rating: 8.2,
    episodes: "126 分钟",
    director: "Elena Marsh",
    cast: ["Noah Bennett", "Clara Voss", "Ivan Petrov"],
    tagline: "当太阳第七次落下，时间会给出答案。",
    summary:
      "一支勘测队在荒漠深处发现一座会移动的观测塔。每当太阳落下，塔内的时钟就会倒退二十四小时，而队员的记忆却完整保留。",
    synopsis:
      "荒漠的白天有四十七度，夜里能听见石头裂开的声音。勘测队原本只是来测量一条干涸河道，却在一场沙暴后遇见那座不该存在的塔。第一次日落，他们失去了通讯；第二次，他们丢了一辆车；第三次，有人开始记得还没发生的事。队长艾萨克必须在第七次日落之前，找出这座塔真正的目的。影片以极简的场景设计和层层递进的悬念，构建一段关于选择与代价的科幻寓言。",
    tags: ["时间循环", "荒漠", "悬疑", "科幻寓言"],
    heat: 8120,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20lone%20traveler%20watching%20an%20enormous%20amber%20sun%20set%20behind%20cracked%20desert%20cliffs%2C%20layered%20peach%20and%20terracotta%20sky%2C%20long%20shadows%2C%20dust%20in%20the%20air%2C%20surreal%20science%20fiction%20atmosphere%2C%20minimal%20composition&width=480&height=672&seq=mt-m004-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20desert%20landscape%20at%20sunset%20with%20a%20strange%20black%20observation%20tower%20on%20the%20horizon%2C%20huge%20amber%20sun%2C%20layered%20peach%20and%20terracotta%20clouds%2C%20dust%20haze%2C%20cinematic%20science%20fiction%20film%20still&width=1600&height=900&seq=mt-hero-m004&orientation=landscape",
  },
  {
    id: "m005",
    title: "山谷回声",
    originalTitle: "ECHOES IN THE VALLEY",
    type: "movie",
    genres: ["冒险", "剧情"],
    region: "中国台湾",
    year: 2024,
    rating: 8.1,
    episodes: "111 分钟",
    director: "许青禾",
    cast: ["高柏宇", "曾之遥", "林牧"],
    tagline: "走进山谷的人，都会带走一点自己的声音。",
    summary:
      "声音采集师阿牧进入一座即将被水库淹没的山谷，为它录下最后的声音。在寻找传说中“会回话的岩壁”时，他遇见了守山三十年的老人。",
    synopsis:
      "山谷里的人说话都有回音，老人说那是山在替你记住。阿牧带着录音设备挨家挨户收集声音：清晨的溪水、午后的蝉、深夜的狗吠，还有一户人家唱了一半就停下的歌。随着蓄水日期临近，他发现自己录下的磁带里，混进了不属于这个山谷的声音。影片把纪录片的耐心和剧情的温度揉在一起，安静却有力量。",
    tags: ["山谷", "声音采集", "即将消失", "人与自然"],
    heat: 6240,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20narrow%20misty%20mountain%20valley%20with%20a%20winding%20river%2C%20soft%20peach%20morning%20light%20through%20pine%20trees%2C%20tiny%20hiker%20silhouette%2C%20layered%20ridgelines%20fading%20into%20haze%2C%20quiet%20adventure%20mood%2C%20painterly%20texture&width=480&height=672&seq=mt-m005-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20misty%20mountain%20valley%20at%20dawn%20with%20a%20river%20winding%20through%20pine%20forest%2C%20warm%20peach%20light%20breaking%20through%20fog%2C%20layered%20ridges%2C%20cinematic%20nature%20documentary%20film%20still&width=1600&height=900&seq=mt-hero-m005&orientation=landscape",
  },
  {
    id: "m006",
    title: "无名舞台",
    originalTitle: "STAGE WITHOUT A NAME",
    type: "movie",
    genres: ["音乐", "剧情"],
    region: "日本",
    year: 2022,
    rating: 8.5,
    episodes: "107 分钟",
    director: "森岛遥",
    cast: ["青木遥人", "小林千鹤", "佐野元"],
    tagline: "灯亮起来的那一刻，我们就不算无名。",
    summary:
      "一家只有二十四个座位的小剧场即将关门。最后一场演出前，调音师、演员和一位不请自来的观众，决定把这场戏演完。",
    synopsis:
      "剧场的木地板踩上去会响，那是三十年来所有演员留下的节奏。老板宣布下个月闭馆后，剧团只剩三个人还愿意排练。调音师美咲发现，仓库深处还堆着一批从未上演的剧本，作者栏是空的。他们决定用最后一场演出，把这些没被听见的台词讲出来。影片几乎全部发生在这间小剧场内，用光线的变化和音乐的层次撑起情绪的起伏。",
    tags: ["小剧场", "音乐", "告别演出", "治愈"],
    heat: 6890,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20an%20empty%20small%20theater%20stage%20with%20a%20single%20spotlight%2C%20velvet%20curtains%20in%20warm%20rose%20tones%2C%20wooden%20floor%20reflections%2C%20sheet%20music%20on%20a%20stool%2C%20intimate%20music%20drama%20mood%2C%20dust%20particles%20in%20light&width=480&height=672&seq=mt-m006-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Intimate%20small%20theater%20stage%20lit%20by%20a%20warm%20spotlight%2C%20empty%20wooden%20seats%2C%20dust%20floating%20in%20the%20beam%2C%20peach%20and%20rose%20tones%2C%20cinematic%20music%20drama%20film%20still&width=1600&height=900&seq=mt-hero-m006&orientation=landscape",
  },
  {
    id: "t001",
    title: "春风里的小院",
    originalTitle: "SPRING IN THE COURTYARD",
    type: "tv",
    genres: ["家庭", "治愈", "剧情"],
    region: "中国大陆",
    year: 2025,
    rating: 9.0,
    episodes: "全 28 集",
    director: "温以棠",
    cast: ["苏晴", "顾宛之", "陈奶奶", "林一诺"],
    tagline: "春天每年都会来，小院也每年都开门。",
    summary:
      "退休教师林奶奶把自家庭院改成社区共享小院，四个陌生家庭因为一张拼桌，慢慢变成了彼此的家人。",
    synopsis:
      "春风里的小院有一棵老桃树，开花的时候整条巷子都是甜的。林奶奶原本只想找人陪着吃晚饭，没想到来的人越来越多：刚搬来的年轻夫妇、在附近上学的高三女孩、做了三十年面点的单身大叔，还有总说“只坐一次”的旧邻居。二十八集里，小院经历了一整个四季——有人搬走，有人回来，有误会，也有和解。剧集以温柔细密的生活切面，讲一个关于陪伴与重新开始的故事。",
    tags: ["共享小院", "邻里", "治愈", "四季"],
    heat: 9860,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20sunlit%20Chinese%20courtyard%20house%20with%20peach%20blossom%20branches%2C%20wooden%20tables%20and%20clay%20teapots%2C%20laundry%20swaying%20in%20a%20warm%20spring%20breeze%2C%20soft%20pink%20petals%20in%20the%20air%2C%20healing%20family%20drama%20mood%2C%20painterly%20key%20art&width=480&height=672&seq=mt-t001-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20sunlit%20traditional%20Chinese%20courtyard%20with%20a%20blooming%20peach%20tree%2C%20long%20wooden%20table%20with%20teapots%20and%20plates%2C%20hanging%20lanterns%2C%20warm%20spring%20afternoon%20light%2C%20petals%20drifting%2C%20cinematic%20family%20drama%20still&width=1600&height=900&seq=mt-hero-t001&orientation=landscape",
  },
  {
    id: "t002",
    title: "暗夜灯塔",
    originalTitle: "THE DARK BEACON",
    type: "tv",
    genres: ["悬疑", "犯罪", "剧情"],
    region: "中国香港",
    year: 2024,
    rating: 8.8,
    episodes: "全 20 集",
    director: "邓启峰",
    cast: ["方志远", "温晴", "罗青山", "叶霈"],
    tagline: "灯塔照的是海，也是人心里最暗的地方。",
    summary:
      "偏远海岛连续出现渔船失踪事件，新任灯塔看守发现，每一艘失踪的船都曾在夜里看见同一个信号。",
    synopsis:
      "海岛只有一班船，每周三来一次。新来的灯塔看守程默原本只想安静待满一年，却在第一晚就收到一串不属于航标的灯光。警局以天气原因结案，渔民却开始悄悄收拾行李。程默与当地记者温晴一起查访旧港口，发现二十年来所有失踪船只的航线，都在某个坐标上短暂重合。剧集用潮湿、灰冷的影像与克制的配乐，铺开一场关于沉默共识的犯罪故事。",
    tags: ["海岛", "灯塔", "罪案", "双线叙事"],
    heat: 9120,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20tall%20lighthouse%20beam%20cutting%20through%20heavy%20night%20fog%20over%20a%20rocky%20coast%2C%20cool%20shadows%20warmed%20by%20amber%20lamp%20glow%2C%20crashing%20waves%2C%20mysterious%20crime%20thriller%20mood%2C%20minimal%20silhouette%20composition&width=480&height=672&seq=mt-t002-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20dramatic%20shot%20of%20a%20lighthouse%20on%20a%20rocky%20island%20at%20night%2C%20thick%20fog%2C%20a%20single%20fishing%20boat%20in%20dark%20water%2C%20warm%20beacon%20light%20against%20cold%20blue%20shadows%2C%20cinematic%20crime%20thriller%20still&width=1600&height=900&seq=mt-hero-t002&orientation=landscape",
  },
  {
    id: "t003",
    title: "高楼十二层",
    originalTitle: "THE TWELFTH FLOOR",
    type: "tv",
    genres: ["都市", "职场", "剧情"],
    region: "中国大陆",
    year: 2025,
    rating: 8.3,
    episodes: "全 24 集",
    director: "闵川",
    cast: ["梁书言", "赵一鸣", "钱朵朵", "孙蓉"],
    tagline: "十二层没有窗户，但每个人都在看风景。",
    summary:
      "一家即将被收购的广告公司里，十二层的四个部门为了同一份方案明争暗斗，而真正的难题是：谁还愿意留下。",
    synopsis:
      "十二层的灯常年亮到凌晨，会议室的白板上写满了改了十七版的方案。创意总监梁书言接到收购通知的那天，团队里最会写文案的人刚好递了辞呈。四个部门为了争取被保留的名额，开始了一场没有明说的较量。剧集把会议室、茶水间、加班夜和电梯间里的沉默都拍得很细，既有职场的锋利，也有普通人在不确定里彼此照应的那一点暖。",
    tags: ["广告公司", "职场群像", "收购", "成长"],
    heat: 8450,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20modern%20office%20tower%20at%20night%20seen%20through%20rain%20streaked%20glass%2C%20warm%20peach%20interior%20lights%20in%20grid%20windows%2C%20one%20lit%20floor%20standing%20out%2C%20urban%20workplace%20drama%20mood%2C%20reflective%20minimal%20key%20art&width=480&height=672&seq=mt-t003-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Modern%20office%20tower%20at%20night%20with%20warm%20peach%20lit%20windows%2C%20rain%20on%20glass%2C%20city%20lights%20bokeh%2C%20empty%20open%20plan%20office%20interior%20in%20foreground%2C%20cinematic%20workplace%20drama%20still&width=1600&height=900&seq=mt-hero-t003&orientation=landscape",
  },
  {
    id: "t004",
    title: "白鹭长歌",
    originalTitle: "SONG OF THE EGRETS",
    type: "tv",
    genres: ["古装", "爱情", "剧情"],
    region: "中国大陆",
    year: 2023,
    rating: 8.6,
    episodes: "全 36 集",
    director: "沈疏影",
    cast: ["云清和", "裴照雪", "宋知渡", "林晏"],
    tagline: "山河很大，容得下两个不肯低头的人。",
    summary:
      "掌管水运文书的女子与一位被贬的年轻将军，在江南水患中被迫合作。一场关于堤坝与权谋的较量，也成了他们彼此的救赎。",
    synopsis:
      "白鹭洲的堤坝每年都要修，账本上的银子却每年都不够。沈家二女沈砚秋接手水运文书的第一天，就发现账目里藏着一条看不见的河。被贬到江南的将军裴照雪负责督工，两人一个查账一个修堤，从互相怀疑到不得不把后背交给对方。三十六集的篇幅里，有朝堂的暗流，也有雨夜里一盏灯、一碗热汤的诚意。服化道清雅，台词克制，感情线慢而稳。",
    tags: ["江南", "水患", "古装群像", "双向奔赴"],
    heat: 8760,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20figure%20in%20flowing%20pale%20silk%20hanfu%20standing%20in%20a%20bamboo%20forest%20with%20egrets%20flying%2C%20soft%20peach%20and%20ivory%20tones%2C%20drifting%20mist%2C%20ancient%20Chinese%20costume%20drama%20mood%2C%20painterly%20classical%20key%20art&width=480&height=672&seq=mt-t004-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20waterfront%20town%20at%20dusk%20with%20stone%20embankment%20and%20moored%20wooden%20boats%2C%20egrets%20flying%20over%20the%20river%2C%20peach%20and%20ivory%20light%2C%20mist%20over%20water%2C%20cinematic%20costume%20drama%20still&width=1600&height=900&seq=mt-hero-t004&orientation=landscape",
  },
  {
    id: "t005",
    title: "便利店凌晨三点",
    originalTitle: "3AM CONVENIENCE STORE",
    type: "tv",
    genres: ["生活", "治愈", "剧情"],
    region: "韩国",
    year: 2024,
    rating: 8.7,
    episodes: "全 12 集",
    director: "Han Ji-woo",
    cast: ["Seo Min-jae", "Yoon Ha-eun", "Park Do-hyun"],
    tagline: "凌晨三点还亮着的店，收留所有睡不着的人。",
    summary:
      "夜班店员与一位每晚都来买同一种饭团的客人，在一间二十四小时便利店里，看见十二个普通人的深夜故事。",
    synopsis:
      "这家便利店在巷口，凌晨三点以后几乎没有客人。夜班店员河恩每天整理货架、煮关东煮、听收银机发出短促的响声。常来的那个人总在三点零五分推门，买一个金枪鱼饭团和一瓶温热的豆奶，从不多说一句话。十二集里，每个深夜进门的客人都带着一个小小的难题：加班的实习生、吵架的情侣、跑长途的司机、刚结束考试的少年。剧集不急着给答案，只是让灯一直亮着。",
    tags: ["深夜", "便利店", "单元故事", "温柔"],
    heat: 7960,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20small%20convenience%20store%20glowing%20warmly%20at%20three%20in%20the%20morning%20on%20a%20quiet%20street%2C%20peach%20and%20amber%20light%20spilling%20onto%20wet%20pavement%2C%20lone%20customer%20silhouette%20inside%2C%20cozy%20slice%20of%20life%20mood%2C%20soft%20bokeh&width=480&height=672&seq=mt-t005-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Quiet%20city%20alley%20at%203am%20with%20a%20warm%20glowing%20convenience%20store%2C%20wet%20pavement%20reflections%2C%20peach%20and%20amber%20light%2C%20empty%20street%2C%20cinematic%20slice%20of%20life%20drama%20still&width=1600&height=900&seq=mt-hero-t005&orientation=landscape",
  },
  {
    id: "t006",
    title: "灰蓝海岸线",
    originalTitle: "THE GREY COAST",
    type: "tv",
    genres: ["悬疑", "剧情"],
    region: "韩国",
    year: 2025,
    rating: 8.5,
    episodes: "全 16 集",
    director: "Choi Eun-sol",
    cast: ["Jung Woo-jin", "Lee Seo-ah", "Kim Tae-hyun"],
    tagline: "海岸线退后一米，秘密就露出一寸。",
    summary:
      "海岸公路旁的小镇因一场台风露出沉船残骸，也让十五年前的一桩旧案重新浮出水面。",
    synopsis:
      "台风过境后的清晨，镇上的孩子在海滩上捡到一枚生锈的铜牌。警员郑宇镇本想按惯例登记了事，却在铜牌背后看见了自己父亲的名字。随着潮水一次次退去，沉船的一部分逐渐露出，小镇当年最体面的那户人家开始频繁出入律师事务所。剧集用灰蓝的海、漫长的公路和几乎不说话的人物，讲一个关于集体沉默的故事。画面克制，但每一次涨潮都像在逼近真相。",
    tags: ["海岸小镇", "旧案", "台风", "群像"],
    heat: 8320,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20desolate%20coastline%20with%20a%20single%20parked%20car%20and%20cliffs%2C%20muted%20peach%20sky%20over%20a%20cold%20grey%20sea%2C%20long%20empty%20road%2C%20quiet%20mystery%20drama%20mood%2C%20wide%20minimal%20composition%2C%20fine%20grain&width=480&height=672&seq=mt-t006-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Grey%20coastal%20highway%20with%20crashing%20waves%20and%20a%20lonely%20car%2C%20overcast%20peach%20sky%2C%20wet%20asphalt%20reflections%2C%20cliffs%20and%20sea%20mist%2C%20cinematic%20mystery%20drama%20film%20still&width=1600&height=900&seq=mt-hero-t006&orientation=landscape",
  },
  {
    id: "v001",
    title: "荒野厨房",
    originalTitle: "WILD KITCHEN",
    type: "variety",
    genres: ["真人秀", "美食", "户外"],
    region: "中国大陆",
    year: 2025,
    rating: 9.1,
    episodes: "全 12 期",
    director: "周牧野",
    cast: ["主理人 · 陈野", "主厨 · 苏禾", "飞行嘉宾 · 江小满"],
    tagline: "把厨房搬到没有信号的地方。",
    summary:
      "三位料理人带着一口锅和一把刀，走进草原、海岛与雪山，用当地食材为陌生人做一顿饭。",
    synopsis:
      "节目没有棚拍，也没有固定菜单。每一期，三位料理人抵达一个新的地方，先跟着当地人认识食材，再去集市换东西，最后在野外生火做饭。草原上的一锅手抓饭、渔村里的海鲜汤、雪山脚下的热面团，食物成了最直接的语言。节目把镜头大量留给了等待、火候和吃饭时的沉默，也留给了那些端着碗笑得有点害羞的普通人。",
    tags: ["户外料理", "在地食材", "慢综艺", "烟火气"],
    heat: 9940,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20an%20open%20fire%20cooking%20scene%20in%20a%20wild%20meadow%20at%20golden%20hour%2C%20cast%20iron%20pan%20with%20vegetables%2C%20warm%20peach%20and%20amber%20light%2C%20smoke%20drifting%2C%20camping%20gear%20and%20rolling%20hills%2C%20joyful%20outdoor%20reality%20show%20mood&width=480&height=672&seq=mt-v001-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Outdoor%20camp%20kitchen%20in%20a%20vast%20grassland%20at%20golden%20hour%2C%20open%20fire%20and%20cast%20iron%20pot%2C%20smoke%20rising%2C%20three%20figures%20cooking%20together%2C%20warm%20peach%20light%2C%20cinematic%20reality%20show%20still&width=1600&height=900&seq=mt-hero-v001&orientation=landscape",
  },
  {
    id: "v002",
    title: "声音的旅行",
    originalTitle: "JOURNEY OF SOUND",
    type: "variety",
    genres: ["音乐", "真人秀"],
    region: "中国大陆",
    year: 2024,
    rating: 8.8,
    episodes: "全 10 期",
    director: "尹千帆",
    cast: ["音乐人 · 顾遥", "音乐人 · 阿曼", "特邀 · 白露"],
    tagline: "不带舞台，只带耳朵去旅行。",
    summary:
      "每期一位音乐人离开录音棚，去一座小城收集声音：清晨的菜市场、午后的旧电影院、傍晚的渡口，最后写成一首歌。",
    synopsis:
      "节目组给每位音乐人七天时间、一台便携录音机和一张单程车票。没有乐队，没有修音，只要求在离开那座城市前，把一路上听见的声音变成一首完整的歌。有人把渡轮的汽笛做成了前奏，有人采样了面馆里沸腾的水声。第十期，所有音乐人回到同一间小剧场，唱出各自的声音旅行。节目把创作过程完整地留在镜头里，包括卡住的时候。",
    tags: ["采风", "原创音乐", "小城", "创作过程"],
    heat: 7820,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20an%20intimate%20live%20music%20stage%20with%20vintage%20microphones%20and%20warm%20peach%20stage%20lights%2C%20silhouettes%20of%20musicians%2C%20floating%20notes%20of%20light%2C%20joyful%20music%20variety%20show%20mood%2C%20soft%20haze&width=480&height=672&seq=mt-v002-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Small%20intimate%20music%20venue%20with%20warm%20peach%20stage%20lighting%2C%20vintage%20microphone%20and%20guitar%20on%20stage%2C%20empty%20wooden%20chairs%2C%20hazy%20atmosphere%2C%20cinematic%20music%20variety%20show%20still&width=1600&height=900&seq=mt-hero-v002&orientation=landscape",
  },
  {
    id: "v003",
    title: "山海慢行记",
    originalTitle: "SLOW ROAD BY THE SEA",
    type: "variety",
    genres: ["旅行", "纪实"],
    region: "中国大陆",
    year: 2024,
    rating: 8.9,
    episodes: "全 8 期",
    director: "路遥川",
    cast: ["行者 · 沈川", "摄影 · 何夕"],
    tagline: "开得慢一点，才看得见路边的风景。",
    summary:
      "两个人、一辆旧房车，沿着海岸线行驶三千公里。没有任务，没有打卡，只有沿途遇见的村庄与人。",
    synopsis:
      "节目从一座渔港出发，沿着海岸公路向南，全程不设行程表。房车需要加油的时候就停，遇见好看的海湾就多住两天。他们在晒盐场帮工，在小学的操场上放了一场露天电影，也在台风天被困在便利店门口聊了一整夜。八期节目没有高潮迭起的戏剧性，只有越来越慢的语速和越来越长的镜头。看完会想给某个很久没联系的人打个电话。",
    tags: ["房车旅行", "海岸公路", "纪实", "慢生活"],
    heat: 7450,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20winding%20coastal%20mountain%20road%20with%20a%20small%20camper%20van%2C%20terraced%20fields%20and%20sea%20in%20the%20distance%2C%20warm%20peach%20sunrise%20light%2C%20travel%20documentary%20mood%2C%20wide%20cinematic%20composition&width=480&height=672&seq=mt-v003-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Coastal%20mountain%20road%20at%20sunrise%20with%20a%20camper%20van%20driving%20along%20the%20sea%2C%20warm%20peach%20sky%2C%20terraced%20hills%2C%20calm%20ocean%2C%20cinematic%20travel%20documentary%20film%20still&width=1600&height=900&seq=mt-hero-v003&orientation=landscape",
  },
  {
    id: "v004",
    title: "即兴喜剧之夜",
    originalTitle: "IMPROV NIGHT",
    type: "variety",
    genres: ["喜剧", "真人秀"],
    region: "中国大陆",
    year: 2023,
    rating: 8.6,
    episodes: "全 14 期",
    director: "钱多多",
    cast: ["领队 · 老周", "演员 · 小满", "演员 · 阿凯", "演员 · 林奇"],
    tagline: "没有剧本，笑声就是唯一的剧本。",
    summary:
      "四组喜剧演员在没有剧本的情况下，用观众随机给出的关键词现场搭建故事，每一期都是一次无法复制的演出。",
    synopsis:
      "舞台很简单：几把椅子、一块黑板、一个装关键词的箱子。观众写下任何词，演员抽到什么就得演什么。有人抽到“电梯里的第七个人”，有人抽到“妈妈的旧毛衣”，于是故事就在毫无准备的情况下长出来。节目保留了所有失败的尝试和笑场，因为那些才是即兴真正的样子。第十四期，四组演员一起完成了一场只有一个关键词的完整长剧。",
    tags: ["即兴", "现场", "观众互动", "欢乐"],
    heat: 6980,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20small%20comedy%20club%20stage%20with%20a%20vintage%20microphone%20and%20wooden%20stool%2C%20warm%20peach%20spotlight%2C%20brick%20wall%20background%2C%20laughing%20audience%20silhouettes%2C%20playful%20variety%20show%20mood&width=480&height=672&seq=mt-v004-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cozy%20comedy%20club%20interior%20with%20warm%20peach%20spotlight%20on%20an%20empty%20stage%2C%20brick%20walls%2C%20rows%20of%20wooden%20chairs%2C%20hanging%20bulbs%2C%20cinematic%20variety%20show%20still&width=1600&height=900&seq=mt-hero-v004&orientation=landscape",
  },
  {
    id: "v005",
    title: "星空露营计划",
    originalTitle: "CAMP UNDER THE STARS",
    type: "variety",
    genres: ["户外", "真人秀"],
    region: "中国大陆",
    year: 2025,
    rating: 8.4,
    episodes: "全 10 期",
    director: "顾星野",
    cast: ["营长 · 山子", "飞行嘉宾 · 陆续", "飞行嘉宾 · 苏苏"],
    tagline: "把手机留在山下，把星星带回家。",
    summary:
      "每期邀请三位城市来客，在没有信号的营地住两晚。搭帐篷、生火、做饭，以及一场没有主题的夜谈。",
    synopsis:
      "营地在山上，信号到半山腰就断了。节目组只提供帐篷、食材和一张手绘地图。来客需要自己搭好住处，去溪边取水，在太阳落山前把饭做熟。夜里没有安排，大家围着火坐着，话题从工作聊到小时候，再聊到那些没能实现的想法。有人第一次看见银河，有人在火光里把一直没说的话讲完。节目把大量时间留给了安静，也留给了抬头。",
    tags: ["露营", "星空", "夜谈", "无信号"],
    heat: 7210,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20glowing%20tent%20on%20a%20grassy%20hill%20under%20a%20wide%20starry%20sky%2C%20warm%20peach%20lantern%20light%2C%20silhouettes%20of%20friends%20around%20a%20small%20campfire%2C%20outdoor%20reality%20show%20mood%2C%20gentle%20milky%20way&width=480&height=672&seq=mt-v005-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Starry%20night%20campsite%20on%20a%20hill%20with%20two%20glowing%20tents%20and%20a%20small%20campfire%2C%20milky%20way%20above%2C%20warm%20peach%20lantern%20glow%2C%20cinematic%20outdoor%20reality%20show%20still&width=1600&height=900&seq=mt-hero-v005&orientation=landscape",
  },
  {
    id: "v006",
    title: "一日店长",
    originalTitle: "ONE DAY SHOPKEEPER",
    type: "variety",
    genres: ["生活", "经营"],
    region: "中国台湾",
    year: 2024,
    rating: 8.3,
    episodes: "全 12 期",
    director: "蔡雨青",
    cast: ["店长 · 阿青", "常驻 · 小纪", "飞行嘉宾 · 温温"],
    tagline: "给你一间店，只营业一天。",
    summary:
      "每期把一间小店交给一位素人或艺人打理一天，从备货、定价到接待客人，全部自己来。",
    synopsis:
      "节目选的都是很普通的小店：街角的甜品店、山下的杂货铺、巷子里的花店。店长只有一天时间，要看完前任留下的手写笔记、决定今天卖什么、算出该定多少钱，还要在天黑前把账做平。有人手忙脚乱把糖煮糊，有人意外发现了自己很会招呼客人。收摊之后，店长会坐在门口吃一碗剩下的东西，聊聊这一天的感受。",
    tags: ["小店", "经营体验", "素人", "温暖"],
    heat: 6610,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20cozy%20little%20dessert%20shop%20interior%20with%20a%20wooden%20counter%20and%20hanging%20lamps%2C%20warm%20peach%20afternoon%20light%20through%20window%2C%20cakes%20on%20display%2C%20lifestyle%20variety%20show%20mood%2C%20soft%20shadows&width=480&height=672&seq=mt-v006-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Warm%20small%20dessert%20shop%20interior%20at%20golden%20hour%2C%20wooden%20counter%20with%20cakes%2C%20hanging%20lamps%2C%20open%20door%20with%20street%20view%2C%20peach%20afternoon%20light%2C%20cinematic%20lifestyle%20variety%20show%20still&width=1600&height=900&seq=mt-hero-v006&orientation=landscape",
  },
];